import API from "../../api";

const SET_LIST = "SET_LIST";
const SET_ALL = "SET_ALL";
const SET_PRELOADER = "SET_PRELOADER";
const SET_TOTALS_PAGINATION = "SET_TOTALS_PAGINATION";
const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";

export default {
  namespaced: true,

  state: {
    list: "",
    all: [],
    pagination: {
      current: 1,
      totalPages: 1,
      totalResults: 1
    },
    sort: "",
    preloader: false
  },

  actions: {
    async list({ state, commit }) {
      commit("SET_PRELOADER", true);

      try {
        let results = await API.States.index(state.pagination.current);
        commit("SET_TOTALS_PAGINATION", results.meta);
        commit("SET_LIST", results.data);
      } catch (e) {
        throw e;
      }

      commit("SET_PRELOADER", false);
    },

    async listAll({ commit }) {
      commit("SET_PRELOADER", true);

      try {
        let results = await API.States.all();
        commit("SET_ALL", results.data);
      } catch (e) {
        throw e;
      }

      commit("SET_PRELOADER", false);
    },

    async create({ commit }, data) {
      try {
        await API.States.create(data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    setCurrentPage({ commit, dispatch }, page) {
      commit("SET_CURRENT_PAGE", page);
      dispatch("listAll");
    }
  },

  mutations: {
    [SET_LIST](state, payload) {
      state.list = payload;
    },
    [SET_ALL](state, payload) {
      state.all = payload;
    },
    [SET_PRELOADER](state, payload) {
      state.preloader = payload;
    },
    [SET_TOTALS_PAGINATION](state, payload) {
      state.pagination.totalPages = payload.page_count;
      state.pagination.totalResults = payload.record_count;
    },
    [SET_CURRENT_PAGE](state, payload) {
      state.pagination.current = payload;
    }
  },

  getters: {
    states(state) {
      if (state.all.length) {
        return state.all.map(el => {
          return {
            id: el.id,
            name: el.attributes.display_name,
            code: el.attributes.code
          };
        });
      } else {
        return [];
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/states.js